// extracted by mini-css-extract-plugin
export var lg = "_4k-4";
export var md = "_4k-3";
export var sm = "_4k-2";
export var xs = "_4k-1";
export var xxs = "_4k-0";